import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const FilterModal = ({
  title,
  options,
  selectedOptions,
  setSelectedOptions,
  show,
  handleClose
}) => {
  const handleSelectAll = () => {
    setSelectedOptions([...options]);
  };

  const handleUnselectAll = () => {
    setSelectedOptions([]);
  };

  const handleOptionToggle = (option) => {
    setSelectedOptions(prev => {
      const isSelected = prev.some(item => item.code === option.code);
      if (isSelected) {
        return prev.filter(item => item.code !== option.code);
      } else {
        return [...prev, option];
      }
    });
  };

  const isOptionSelected = (option) => {
    return selectedOptions.some(item => item.code === option.code);
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <Button 
            variant="link" 
            className="p-0 me-3" 
            onClick={handleSelectAll}
          >
            Check All
          </Button>
          <Button 
            variant="link" 
            className="p-0" 
            onClick={handleUnselectAll}
          >
            Uncheck All
          </Button>
        </div>
        <Form>
          {options.map((option) => (
            <Form.Check
              key={option.code}
              type="checkbox"
              id={option.code}
              label={option.label}
              checked={isOptionSelected(option)}
              onChange={() => handleOptionToggle(option)}
              className="mb-2"
            />
          ))}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleClose}>
          Apply
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FilterModal;